import React, { useEffect, useMemo, useState } from 'react';
import { InputContainer, Search } from 'finform';
import { useAppSelector } from '#app/hooks/useAppStore';
import { MAIN_CURRENCY_CODES } from '#app/constants/mainCurrencies';

const InvestSelectCurrency = ({ handleSelectCurrency, investCurrency: currencyProp }) => {
  const currenciesFromStore = useAppSelector((state) => state.interfaceComponents.currencies);
  const passCurrencies = useMemo(() => currenciesFromStore ?? [], [currenciesFromStore]);
  // Проп investCurrency: валюта для фильтрации инвестиций (отдельная от основной валюты приложения в Redux)
  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState(currencyProp);
  const [currencySearch, setCurrencySearch] = useState(currencyProp?.name ?? 'Валюта актива');

  useEffect(() => {
    // Фильтруем passCurrencies, оставляя только нужные валюты
    const filteredCurrencies = passCurrencies.filter((currency) =>
      MAIN_CURRENCY_CODES.includes(currency.code)
    );

    const initialCurrencies = [
      {
        id: 'none',
        name: 'Валюта актива',
        sign: '',
        code: 'none',
      },
      ...filteredCurrencies,
    ];
    setCurrencies(initialCurrencies);
  }, [passCurrencies]);

  const handleSearch = (search) => {
    setCurrencySearch(search);

    const searchItem = currencies.find((item) => item.name === search);
    if (searchItem) {
      setCurrencySearch(searchItem.name);
      setCurrency(searchItem);
    }
  };

  const handleSelect = (item) => {
    if (item) {
      handleSelectCurrency(item);
      setCurrencySearch(item.name);
    } else {
      handleSelectCurrency(null);
      setCurrencySearch('');
    }
  };

  return (
    <InputContainer
      style={{
        maxWidth: '200px',
        marginLeft: 'auto',
      }}
    >
      <Search
        placeholder="Валюта"
        id="currency_id"
        search={currencySearch}
        onSearch={handleSearch}
        onChange={handleSelect}
        options={currencies}
        value={currency}
      />
    </InputContainer>
  );
};

export default InvestSelectCurrency;
